export default "__VITE_ASSET__03d6d6da__"